document.addEventListener('DOMContentLoaded', () => {
  const productSwiper = new Swiper('.products-slider-main', {
    slidesPerView: 1, // 1 slide visible on mobile
    spaceBetween: 20,
    loop: true,
    speed: 800,
    centeredSlides: false,
    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    },
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    },
  });

  // Accordion functionality
  const productAccordions = document.querySelectorAll('.accordion-wrap');
  productAccordions.forEach(accordion => {
    accordion.querySelector('.accordion-title').addEventListener('click', () => {
      accordion.classList.toggle('active');
    });
  });
});
